/* eslint-disable no-unused-vars */
/**
 * Constants for MyAccountPage and related components
 * Centralizes magic strings and enums for better maintainability
 */

// Document Types for file uploads

export enum DocumentType {
  CR_DOCUMENT = 'CR_DOCUMENT',
  VAT_CERTIFICATE = 'VAT_CERTIFICATE',
  NATIONAL_ADDRESS_ID = 'NATIONAL_ADDRESS_ID',
}

// Entity Types for file uploads
export enum EntityType {
  KYB_ATTEMPT = 'KYB_ATTEMPT',
  COMPANY = 'COMPANY',
}

// Document IDs used in the UI
export enum DocumentId {
  COMPANY_REGISTRATION = 'company-registration',
  VAT_CERTIFICATE = 'vat-certificate',
  NATIONAL_ADDRESS = 'national-address',
}

// Mapping from Document ID to Document Type
export const DOCUMENT_ID_TO_TYPE_MAP: Record<string, DocumentType> = {
  [DocumentId.COMPANY_REGISTRATION]: DocumentType.CR_DOCUMENT,
  [DocumentId.VAT_CERTIFICATE]: DocumentType.VAT_CERTIFICATE,
  [DocumentId.NATIONAL_ADDRESS]: DocumentType.NATIONAL_ADDRESS_ID,
};

export enum CompanyEditStep {
  COMPANY_DETAILS = 'company-details',
  UPLOAD_DOCUMENTS = 'upload-documents',
  CONFIRMATION = 'confirmation',
  ERROR = 'error',
}

// Company Edit Step Routes
export const COMPANY_EDIT_STEP_ROUTES = [
  `/${CompanyEditStep.COMPANY_DETAILS}`,
  `/${CompanyEditStep.UPLOAD_DOCUMENTS}`,
  `/${CompanyEditStep.CONFIRMATION}`,
];

// API Endpoints for MyAccount
export const MY_ACCOUNT_API_ENDPOINTS = {
  COMPANY_DETAILS_UPLOAD: 'my-account/company-details/upload',
  TEAMS: 'my-account/teams',
  TEAMS_ACTIVATE: 'my-account/teams/activate',
} as const;

// Navigation Routes
export const MY_ACCOUNT_ROUTES = {
  DASHBOARD: '/my-account',
  COMPANY_EDIT: '/my-account?tab=company-details',
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  COMPANY_DETAILS_UPDATED: 'Company details updated successfully',
  DOCUMENTS_UPLOADED: 'Documents uploaded successfully',
  TEAM_MEMBER_ADDED: 'Team member added successfully',
  TEAM_MEMBER_UPDATED: 'Team member updated successfully',
  TEAM_MEMBER_ACTIVATED: 'Team member activated successfully',
  TEAM_MEMBER_DEACTIVATED: 'Team member deactivated successfully',
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  COMPANY_DETAILS_UPDATE_FAILED: 'Failed to update company details',
  DOCUMENTS_UPLOAD_FAILED: 'Failed to upload documents',
  TEAM_MEMBER_ADD_FAILED: 'Failed to add team member',
  TEAM_MEMBER_UPDATE_FAILED: 'Failed to update team member',
  TEAM_MEMBER_STATUS_UPDATE_FAILED: 'Failed to update team member status',
  FORM_VALIDATION_FAILED: 'Form validation failed',
  DOWNLOAD_LINK_EXPIRED:
    'The download link for this document has expired. Please contact support to request a new download link.',
  DOWNLOAD_FAILED: 'Failed to download document',
} as const;
